<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">
                {{ snackbar_msg }}
            </span>
            <v-btn dark text @click="snackbar = false">
                Close
            </v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-data-table :headers="headers" :items="exam_plan_details" class="elevation-1 mytable" dense :search="search">

                <template v-slot:item.sno="{ item }">
                    {{ exam_plan_details.indexOf(item) + 1 }}
                </template>

                <template v-slot:item.standards_streams="{ item }">
                    <div class="d-flex align-center justify-center">
                        <div class="text-center mr-2">
                            <div v-if="item.standards && item.standards.length">
                                <strong>Std:</strong> {{ formatStandards(item.standards) }}
                            </div>

                            <div v-if="item.streams && item.streams.length">
                                <strong>Str:</strong> {{ formatList(item.streams) }}
                            </div>
                        </div>

                        <v-btn icon x-small color="primary" @click="openLinkStandardStreamModal(item)" :disabled="exam_plan_data.is_seating_freezed">
                            <v-icon small>mdi-plus-circle</v-icon>
                        </v-btn>
                    </div>
                </template>

                <template v-slot:item.seating_arrangemnent="{ item }">
                      <v-btn color="blue darken-1" text small :disabled="!canGenerateSeating"
                        @click="proceedGeneratePersonalizedTimeTable(item)">
                        Generate Seating Arrangement
                    </v-btn>
                </template>

                <template v-slot:item.subjects_count="{ item }">
                    <v-btn text small color="primary" type="button" class="font-weight-bold pa-0 min-width-auto"
                        @click.stop.prevent="openSubjectsModal(item)" :disabled="exam_plan_data.is_seating_freezed">
                        <u>{{ item.subjects_count || 0 }}</u>
                        <v-icon right small class="ml-1">mdi-plus-circle</v-icon>
                    </v-btn>
                </template>

                <template v-slot:item.link_rooms_count="{ item }">
                    <v-btn text small color="primary" type="button" class="font-weight-bold pa-0 min-width-auto"
                        :disabled="!item.subjects_count || item.subjects_count == 0 || exam_plan_data.is_seating_freezed" @click.stop.prevent="openRoomsModal(item)">
                        <u>{{ item.link_rooms_count || 0 }}</u>
                        <v-icon right small class="ml-1">mdi-plus-circle</v-icon>
                    </v-btn>
                </template>

                <template v-slot:item.link_supervisor_count="{ item }">
                    <v-btn text small color="primary" type="button" class="font-weight-bold pa-0 min-width-auto"
                        :disabled="!item.subjects_count || item.subjects_count == 0 || exam_plan_data.is_seating_freezed" @click.stop.prevent="openSupervisorModal(item)">
                        <u>{{ item.link_supervisor_count || 0 }}</u>
                        <v-icon right small class="ml-1">mdi-plus-circle</v-icon>
                    </v-btn>
                </template>

                <template v-slot:item.mark_attendance="{ item }">
                    <span class="text-decoration-underline font-weight-bold primary--text">
                        {{ item.totalStudentsInSeating || 0 }} / {{ item.total_students || 0 }}
                    </span>
                </template>

                <template v-slot:item.seating_arrangement="{ item }">
                    <div class="d-flex justify-center align-center">
                        <v-btn color="blue darken-1" text small :disabled="!canGenerateSeating"
                            @click="proceedGeneratePersonalizedTimeTable(item)">
                            Generate Seating Arrangement
                        </v-btn>
                    </div>
                </template>

                <template v-slot:item.action="{ item }">
                    <div class="d-flex justify-center align-center">
                        <v-btn icon small color="primary" class="mr-1" @click="editItem(item)" :disabled="exam_plan_data.is_seating_freezed">
                            <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon small color="error" class="mr-2" @click="deleteItem(item)" :disabled="exam_plan_data.is_seating_freezed">
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                    </div>
                </template>

                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Exam Plan Details</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <div class="pa-4">
                        <table class="simple-exam-table">
                            <thead>
                                <tr>
                                    <th>Exam Plan</th>
                                    <th>Academic Year</th>
                                    <th>Semester</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>No of Slots in Each Day</th>
                                    <th>Exam Conduct Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ exam_plan_data.exam_name || '-' }}</td>
                                    <td>{{ exam_plan_data.academic_year || '-' }}</td>
                                    <td>{{ exam_plan_data.semester || '-' }}</td>
                                    <td>{{ formatDate(exam_plan_data.start_date) }}</td>
                                    <td>{{ formatDate(exam_plan_data.end_date) }}</td>
                                    <td>{{ exam_plan_data.max_slots_in_day != null ? exam_plan_data.max_slots_in_day : '-' }}</td>
                                    <td>{{ formatList(exam_plan_data.exam_conduct_types) }}</td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr>
                                    <th>Stream</th>
                                    <th>Standard</th>
                                    <th>Is Approved ?</th>
                                    <th>Is Current ?</th>
                                    <th>Is Freezed ?</th>
                                    <th>Is Supervisor Enabled ?</th>
                                    <th>Allow Auto Bench Allocation?</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ formatList(exam_plan_data.streams) }}</td>
                                    <td>{{ formatStandards(exam_plan_data.standards) }}</td>
                                    <td>
                                        <v-switch 
                                            v-model="exam_plan_data.is_approved" 
                                            @change="updateExamPlanStatuses" 
                                            hide-details dense class="ma-0 pa-0 d-inline-flex">
                                        </v-switch>
                                    </td>
                                    <td>
                                        <v-switch 
                                            v-model="exam_plan_data.is_current" 
                                            @change="updateExamPlanStatuses" 
                                            hide-details dense class="ma-0 pa-0 d-inline-flex">
                                        </v-switch>
                                    </td>
                                    <td>
                                        <v-switch 
                                            v-model="exam_plan_data.is_seating_freezed" 
                                            @change="updateExamPlanStatuses" 
                                            hide-details dense class="ma-0 pa-0 d-inline-flex">
                                        </v-switch>
                                    </td>
                                    <td>
                                        <v-switch 
                                            v-model="exam_plan_data.is_supervisor_required" 
                                            @change="updateExamPlanStatuses" 
                                            hide-details dense class="ma-0 pa-0 d-inline-flex">
                                        </v-switch>
                                    </td>
                                    <td>
                                        <v-switch 
                                            v-model="exam_plan_data.allow_auto_bench_allocation" 
                                            @change="updateExamPlanStatuses" 
                                            hide-details dense class="ma-0 pa-0 d-inline-flex">
                                        </v-switch>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <v-row dense justify="center">
                        <v-col cols="12" sm="3" md="3">
                            <v-btn small text color="blue" :disabled="!canGenerateSeating" @click="getExamPlanDataSeating()"><u>Generate Seating Arrangement</u></v-btn>
                        </v-col>
                         <v-col cols="12" sm="3" md="3">
                            <v-btn small text color="success" @click="openSeatingArrangement(exam_plan_data.id)"><u>Seating Arrangement Report</u></v-btn>
                        </v-col>
                         <v-col cols="12" sm="3" md="3">
                            <v-btn small text color="orange" @click="viewRoomReport(exam_plan_data.id)"><u>Room Allotment Report</u></v-btn>
                        </v-col>
                         <v-col cols="12" sm="3" md="3">
                            <v-btn small text color="primary" @click="viewAttendanceReport(exam_plan_data.id)"><u>Student Attendance Report</u></v-btn>
                        </v-col>
                    </v-row>


                    <div class="d-flex justify-center w-100 my-4">
                        <v-card class="pa-4 progress-card" max-width="450" width="100%">
                            <div class="d-flex align-center justify-space-between mb-2">
                                <div class="d-flex align-center">
                                    <v-icon color="indigo darken-2" class="mr-2">mdi-progress-check</v-icon>
                                    <span class="subtitle-1 font-weight-bold grey--text text--dark-3">
                                        Exam Plan Progress
                                    </span>
                                </div>
                                <v-chip x-small color="indigo lighten-5"
                                    class="indigo--text text--darken-2 font-weight-bold px-2">
                                    {{ completedStepsCount }} / {{ stepsList.length }} Completed
                                </v-chip>
                            </div>

                            <v-divider class="mb-3"></v-divider>

                            <v-list dense class="pa-0">
                                <v-list-item v-for="(step, index) in stepsList" :key="index"
                                    class="px-2 py-1 mb-1 rounded-lg step-item"
                                    :class="{ 'step-completed': progressStatus[step.key] }">
                                    <v-list-item-icon class="mr-3 my-0 align-self-center">
                                        <v-icon small
                                            :color="progressStatus[step.key] ? 'green darken-1' : 'grey'">
                                            {{ progressStatus[step.key] ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                                        </v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content class="py-0">
                                        <v-list-item-title
                                            :class="progressStatus[step.key] ? 'green--text text--darken-3 font-weight-bold' : 'grey--text text--darken-1 font-weight-medium'"
                                            class="caption">
                                            {{ index + 1 }}. {{ step.label }}
                                        </v-list-item-title>
                                    </v-list-item-content>

                                    <v-list-item-action class="my-0">
                                        <v-chip x-small
                                            :color="progressStatus[step.key] ? 'green lighten-5' : 'grey lighten-4'"
                                            :class="progressStatus[step.key] ? 'green--text text--darken-2 font-weight-bold' : 'grey--text text--darken-1'"
                                            class="px-2">
                                            {{ progressStatus[step.key] ? 'Completed' : 'Pending' }}
                                        </v-chip>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </div>

                    <v-row dense align="center" class="mb-2">
                        <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2">
                            <v-btn rounded small color="success" outlined :loading="loader" @click="downloadFile">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export
                            </v-btn>

                            <v-btn icon color="primary" class="ml-2" @click="openAddScheduleDialog()">
                                <v-icon medium>mdi-plus-circle</v-icon>
                            </v-btn>
                        </v-col>

                        <v-spacer></v-spacer>

                        <v-col sm="6" md="5" cols="12" class="mr-8">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details />
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-card>

        <!-- Generate Seating Arrangement  -->
        <v-dialog v-model="seating_dailog" max-width="1500px" persistent>
            <v-card class="pa-4 text-center">
                <v-card-title class="headline justify-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
                   Generate Seating Arrangement 
                </v-card-title>
                <v-card-text class="pa-0 mb-4">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="3" md="3">
                            <v-select v-model="exam_sch_std" :items="exam_sch_standard_list" item-value="id" item-text="standard" label="Select Standard" outlined dense
                            hide-details class="mb-3"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-select v-model="exam_sch_str" :items="exam_sch_stream_list" item-value="id" item-text="stream" label="Select Stream" outlined dense
                            hide-details class="mb-3"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-select v-model="exam_sch_div" :items="exam_sch_div_off_list" label="Select Division" item-value="div_of_id" item-text="div_name" outlined dense
                            hide-details class="mb-3"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-select v-model="exam_sch_room" multiple :items="exam_sch_room_list" label="Select Room" item-value="id" item-text="room" outlined dense
                            hide-details class="mb-3"></v-select>
                        </v-col>
                    </v-row>
                    <v-row dense justify="center">
                        <v-col cols="12" sm="12" md="12">
                            <h3 class="text-lg font-bold mb-2">Sorting Options</h3>
                            <v-divider class="mb-3"></v-divider>
                        </v-col>

                        <v-col cols="12" sm="3" md="3">
                            <v-radio-group v-model="sortval1" inline>
                                <v-radio label="Inside Division" value="Division" />
                                <v-radio label="Across Division" value="All" />
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-radio-group v-model="flush_radio" inline>
                                <v-radio label="Generate New(Flush / Delete already generated seating arrangement)" value="Generate New" />
                                <v-radio label="Allocate seats to students who have not yet been assigned seats." value="Allocated Student Specific" />
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12" sm="3" md="3">
                            <v-radio-group v-model="sortval2" inline>
                                <v-radio label="Roll No." value="RollNo" />
                                <v-radio label="PRN" value="PRN" />
                                <v-radio label="Seat No." value="SeatNo" />
                                <v-radio label="LastName FirstName MiddleName" value="Name" />
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-radio-group v-model="benchtype" inline>
                                <v-radio label="All Benches" value="All" />
                                <v-radio label="Odd Benches" value="Odd" />
                                <v-radio label="Even Benches" value="Even" />
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center pa-0">
                    <v-btn v-if="exam_sch_std && exam_sch_str && exam_sch_room" color="primary" :loading="loader" small @click="proceedGenerateSeatingArrangement()">Save</v-btn>
                    <v-btn color="grey" text small @click="seating_dailog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_generate_common_seating" max-width="1500px" persistent>
            <v-card class="pa-4 text-center">
                <v-card-title class="headline justify-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
                   Generate Seating Arrangement 
                </v-card-title>
                <v-card-text class="pa-0 mb-4">
                    <v-row desnse justify="center">
                        <v-col cols="12" sm="3" md="3">
                            <v-select v-model="std" :items="standard_list" item-value="id" item-text="standard" label="Select Standard" outlined dense
                            hide-details class="mb-3"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-select v-model="stream" :items="stream_list" item-value="id" item-text="stream_name" label="Select Stream"  outlined dense
                            hide-details class="mb-3"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-select v-model="div" :items="division_data" label="Select Division" item-value="div_of_id" item-text="div_name" outlined dense
                            hide-details class="mb-3"></v-select>
                        </v-col>
                    </v-row>
                    <v-row desnse justify="center">
                             <v-col cols="12" sm="12" md="12">
                                <h3 class="text-lg font-bold mb-2">Sorting Options</h3>
                                <v-divider class="mb-3"></v-divider>
                            </v-col>

                            <v-col cols="12" sm="3" md="3">
                                <v-radio-group v-model="sortval1" inline>
                                    <v-radio label="Inside Division" value="Division" />
                                    <v-radio label="Across Division" value="All" />
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-radio-group v-model="flush_radio" inline>
                                    <v-radio label="Generate New(Flush / Delete already generated seating arrangement)" value="Generate New" />
                                    <v-radio label="Allocate seats to students who have not yet been assigned seats." value="Allocated Student Specific" />
                                </v-radio-group>
                            </v-col>

                           <v-col cols="12" sm="3" md="3">
                                <v-radio-group v-model="sortval2" inline>
                                    <v-radio label="Roll No." value="RollNo" />
                                    <v-radio label="PRN" value="PRN" />
                                    <v-radio label="Seat No." value="SeatNo" />
                                    <v-radio label="LastName FirstName MiddleName" value="Name" />
                                </v-radio-group>
                            </v-col>
                             <v-col cols="12" sm="3" md="3">
                                <v-radio-group v-model="benchtype" inline>
                                    <v-radio label="All Benches" value="All" />
                                    <v-radio label="Odd Benches" value="Odd" />
                                    <v-radio label="Even Benches" value="Even" />
                                </v-radio-group>
                            </v-col>
                        </v-row>
                </v-card-text>
                <v-card-actions class="justify-center pa-0">
                    <v-btn v-if="std && stream" color="primary"  :loading="loader" small @click="proceedGenerateCommonSeatingArrangement()">Save</v-btn>
                    <v-btn color="grey" text small @click="dialog_generate_common_seating = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
         </v-dialog>

        <!-- Seats not allocated students -->
        <v-dialog v-model="aloocation_dailog" max-width="1500px" persistent>
            <v-card class="pa-4 text-center">
                <v-card-title class="headline justify-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
                    Seats not allocated students 
                </v-card-title>
                <v-card-text class="pa-0 mb-4">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="12" md="12">
                            <v-simple-table dense class="elevation-1 mytable">
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Student</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(index, stud) in allocation_not_done_list" :key="stud">
                                        <td>{{ stud + 1 }}</td>
                                        <td>{{ index }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center pa-0">
                    <v-btn v-if="exam_sch_std && exam_sch_str && exam_sch_room" color="primary" small @click="proceedGenerateSeatingArrangement()">Save</v-btn>
                    <v-btn color="grey" text small @click="aloocation_dailog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Link Subjects -->
        <v-dialog v-model="subjectsDialog" max-width="1200px" persistent>
            <v-card class="pa-4">
                <v-card-title class="headline justify-space-between align-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
                    <span>Link Subjects</span>
                    <v-btn icon @click="closeSubjectsModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-0">
                    <div class="mb-4">
                        <table class="simple-exam-table">
                            <thead>
                                <tr>
                                    <th>Exam Plan</th>
                                    <th>Academic Year</th>
                                    <th>Semester</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Exam Conduct Type</th>
                                    <th>Stream</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ subject_schedule_data.exam_name || '-' }}</td>
                                    <td>{{ subject_schedule_data.academic_year || '-' }}</td>
                                    <td>{{ subject_schedule_data.semester || '-' }}</td>
                                    <td>{{ subject_schedule_data.start_date || '-' }}</td>
                                    <td>{{ subject_schedule_data.end_date || '-' }}</td>
                                    <td>{{ formatList(subject_schedule_data.exam_conduct_types) }}</td>
                                    <td>{{ formatList(subject_schedule_data.streams) }}</td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr>
                                    <th>Standard</th>
                                    <th>Session No</th>
                                    <th>Exam Date</th>
                                    <th>Day</th>
                                    <th>Slot No</th>
                                    <th>From Time</th>
                                    <th>To Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ formatStandards(subject_schedule_data.standards) }}</td>
                                    <td>{{ subject_schedule_data.session_number || '-' }}</td>
                                    <td>{{ formatDate(subject_schedule_data.exam_date) }}</td>
                                    <td>{{ subject_schedule_data.day || '-' }}</td>
                                    <td>{{ subject_schedule_data.slot_no || '-' }}</td>
                                    <td>{{ subject_schedule_data.from_time || '-' }}</td>
                                    <td>{{ subject_schedule_data.to_time || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <v-row dense align="center" class="mb-2">
                        <v-col cols="12" sm="4" class="d-flex align-center">
                            <v-btn rounded small color="success" outlined :loading="subjectLoader" @click="exportSubjectsExcel">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export
                            </v-btn>

                            <v-btn icon color="primary" class="ml-2" type="button" @click.prevent="openAddSubjectModal">
                                <v-icon medium>mdi-plus-circle</v-icon>
                            </v-btn>
                        </v-col>

                        <v-spacer></v-spacer>

                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="subjectSearch" append-icon="search" label="Search" single-line hide-details dense outlined />
                        </v-col>
                    </v-row>

                    <v-data-table :headers="subjectHeaders" :items="linked_subjects" class="elevation-1 mytable" dense :search="subjectSearch">
                        <template v-slot:item.sno="{ item }">
                            {{ linked_subjects.indexOf(item) + 1 }}
                        </template>

                        <template v-slot:item.action="{ item }">
                            <div class="d-flex justify-center align-center">
                                <v-btn icon small color="primary" class="mr-1" @click="editSubjectItem(item)">
                                    <v-icon small>mdi-square-edit-outline</v-icon>
                                </v-btn>
                                <v-btn icon small color="error" class="mr-2" @click="confirmDeleteSubject(item)">
                                    <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions class="justify-end pa-0 mt-4">
                    <v-btn color="grey" text small @click="closeSubjectsModal">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="linkSubjectFormDialog" max-width="400px" persistent>
            <v-card class="pa-4">
                <v-card-title class="headline justify-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
                    {{ editedSubjectId ? 'Edit Linked Subject' : 'Link Subject' }}
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-form ref="linkSubjectForm" v-model="validSubjectForm">
                        <div class="mb-1 font-weight-bold">Exam Conduct Type <span class="red--text">*</span></div>
                        <v-select v-model="newSubject.exam_conduct_type_id" :items="master_conduct_types" item-text="name" item-value="id" placeholder="Select Conduct Type" outlined dense hide-details class="mb-3"></v-select>

                        <div class="mb-1 font-weight-bold">Stream <span class="red--text">*</span></div>
                        <v-select v-model="newSubject.stream_id" :items="master_streams" item-text="name" item-value="id" placeholder="Select Stream" outlined dense hide-details class="mb-3"></v-select>

                        <div class="mb-1 font-weight-bold">Standard <span class="red--text">*</span></div>
                        <v-select v-model="newSubject.standard_id" :items="master_standards" item-text="standard" item-value="id" placeholder="Select Standard" outlined dense hide-details class="mb-3"></v-select>

                        <div class="mb-1 font-weight-bold">Subject <span class="red--text">*</span></div>
                        <v-select v-model="newSubject.course_offering_id" :items="filteredMasterSubjects" item-text="display_name" item-value="id" placeholder="Select Subject" outlined dense hide-details class="mb-4"></v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions class="justify-center pa-0">
                    <v-btn color="primary" small type="button" @click.prevent="editedSubjectId ? updateCoursewiseSchedule() : saveCoursewiseSchedule()">
                        Save
                    </v-btn>
                    <v-btn color="grey" text small @click="closeSubjectFormModal">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Link Rooms -->
        <v-dialog v-model="roomsDialog" max-width="1000px" persistent>
            <v-card class="pa-4">
                <v-card-title class="headline justify-space-between align-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
                    <span>Link Rooms</span>
                    <v-btn icon @click="closeRoomsModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-0">
                    <div class="mb-6">
                        <table class="simple-exam-table">
                            <thead>
                                <tr>
                                    <th>Exam Plan</th>
                                    <th>Academic Year</th>
                                    <th>Semester</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Exam Conduct Type</th>
                                    <th>Stream</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ room_schedule_data.exam_name || '-' }}</td>
                                    <td>{{ room_schedule_data.academic_year || '-' }}</td>
                                    <td>{{ room_schedule_data.semester || '-' }}</td>
                                    <td>{{ room_schedule_data.start_date || '-' }}</td>
                                    <td>{{ room_schedule_data.end_date || '-' }}</td>
                                    <td>{{ formatList(room_schedule_data.exam_conduct_types) }}</td>
                                    <td>{{ formatList(room_schedule_data.streams) }}</td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr>
                                    <th>Standard</th>
                                    <th>Session No</th>
                                    <th>Exam Date</th>
                                    <th>Day</th>
                                    <th>Slot No</th>
                                    <th>From Time</th>
                                    <th>To Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ formatStandards(room_schedule_data.standards) }}</td>
                                    <td>{{ room_schedule_data.session_number || '-' }}</td>
                                    <td>{{ formatDate(room_schedule_data.exam_date) }}</td>
                                    <td>{{ room_schedule_data.day || '-' }}</td>
                                    <td>{{ room_schedule_data.slot_no || '-' }}</td>
                                    <td>{{ room_schedule_data.from_time || '-' }}</td>
                                    <td>{{ room_schedule_data.to_time || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="text-center mb-6">
                        <div class="text-subtitle-2 font-weight-medium grey--text text--dark-1 mb-2">
                            Already Offered Rooms:
                        </div>
                        
                        <div v-if="getSelectedRoomNames.length" class="d-flex flex-wrap justify-center align-center">
                            <v-chip
                                v-for="(name, index) in getSelectedRoomNames"
                                :key="index"
                                outlined
                                color="primary"
                                small
                                class="ma-1 font-weight-medium"
                            >
                                {{ name }}
                            </v-chip>
                        </div>
                        <div v-else class="text-caption grey--text">
                            No rooms offered
                        </div>
                    </div>

                    <div class="text-center my-4">
                        <span class="text-h6 font-weight-bold section-title">Select Rooms</span>
                    </div>

                    <v-container class="px-6 my-2">
                        <v-row justify="center" align="center">
                            <v-col
                                v-for="roomItem in master_rooms"
                                :key="roomItem.id"
                                cols="12"
                                sm="3"
                                md="2"
                                class="py-1 d-flex justify-center"
                            >
                                <v-checkbox
                                    v-model="selected_rooms"
                                    :label="roomItem.room_name"
                                    :value="roomItem.id"
                                    dense
                                    hide-details
                                    class="mt-0"
                                ></v-checkbox>
                            </v-col>
                        </v-row>

                        <div v-if="!master_rooms.length" class="text-center grey--text my-4">
                            No rooms available for this schedule.
                        </div>
                    </v-container>
                </v-card-text>

                <v-card-actions class="justify-center pa-0 mt-4">
                    <v-btn color="primary" class="px-6" type="button" @click.prevent="saveRoomSchedule">
                        Save
                    </v-btn>
                    <v-btn color="grey" text small @click="closeRoomsModal">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Link Supervisor -->
        <v-dialog v-model="supervisorDialog" max-width="1200px" persistent>
            <v-card class="pa-4">
                <v-card-title class="headline justify-space-between align-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
                    <span>Link Supervisor</span>
                    <v-btn icon @click="closeSupervisorModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-0">
                    <!-- Schedule Overview Header Table -->
                    <div class="mb-6">
                        <table class="simple-exam-table">
                            <thead>
                                <tr>
                                    <th>Exam Plan</th>
                                    <th>Academic Year</th>
                                    <th>Semester</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Exam Conduct Type</th>
                                    <th>Stream</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ supervisor_schedule_data.exam_name || '-' }}</td>
                                    <td>{{ supervisor_schedule_data.academic_year || '-' }}</td>
                                    <td>{{ supervisor_schedule_data.semester || '-' }}</td>
                                    <td>{{ supervisor_schedule_data.start_date || '-' }}</td>
                                    <td>{{ supervisor_schedule_data.end_date || '-' }}</td>
                                    <td>{{ formatList(supervisor_schedule_data.exam_conduct_types) }}</td>
                                    <td>{{ formatList(supervisor_schedule_data.streams) }}</td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr>
                                    <th>Standard</th>
                                    <th>Session No</th>
                                    <th>Exam Date</th>
                                    <th>Day</th>
                                    <th>Slot No</th>
                                    <th>From Time</th>
                                    <th>To Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ formatStandards(supervisor_schedule_data.standards) }}</td>
                                    <td>{{ supervisor_schedule_data.session_number || '-' }}</td>
                                    <td>{{ formatDate(supervisor_schedule_data.exam_date) }}</td>
                                    <td>{{ supervisor_schedule_data.day || '-' }}</td>
                                    <td>{{ supervisor_schedule_data.slot_no || '-' }}</td>
                                    <td>{{ supervisor_schedule_data.from_time || '-' }}</td>
                                    <td>{{ supervisor_schedule_data.to_time || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Export, Add Button & Search Row -->
                    <v-row dense align="center" class="mb-4">
                        <v-col cols="12" sm="4" class="d-flex align-center">
                            <v-btn rounded small color="success" outlined :loading="supervisorLoader" @click="exportSupervisorExcel">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export
                            </v-btn>

                            <v-btn small color="primary" class="ml-2" type="button" @click.prevent="openSupervisorFormModal(null)">
                                <v-icon left>mdi-plus-circle</v-icon>
                                Add Supervisor
                            </v-btn>
                        </v-col>

                        <v-spacer></v-spacer>

                        <v-col sm="6" md="4" cols="12">
                            <v-text-field 
                                v-model="supervisorSearch" 
                                append-icon="search" 
                                label="Search Supervisor" 
                                single-line 
                                hide-details 
                                dense 
                                outlined 
                            />
                        </v-col>
                    </v-row>

                    <div class="table-responsive">
                        <v-data-table 
                            :headers="supervisorHeaders" 
                            :items="linked_supervisors" 
                            class="elevation-1 mytable" 
                            dense 
                            :search="supervisorSearch"
                        >
                            <template v-slot:item.s_no="{ item }">
                                {{ linked_supervisors.indexOf(item) + 1 }}
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <div class="d-flex justify-center align-center">
                                    <v-btn icon small color="primary" class="mr-1" @click="openSupervisorFormModal(item)">
                                        <v-icon small>mdi-square-edit-outline</v-icon>
                                    </v-btn>
                                    <v-btn icon small color="error" class="mr-2" @click="deleteSupervisorMapping(item.id)">
                                        <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </v-card-text>

                <v-card-actions class="justify-end pa-0 mt-4">
                    <v-btn color="grey" text small @click="closeSupervisorModal">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="linkSupervisorFormDialog" max-width="450px" persistent>
            <v-card>
                <v-card-title class="text-h6 justify-center primary white--text">
                    {{ supervisorForm.id ? 'Edit Supervisor' : 'Link Supervisor' }}
                </v-card-title>

                <v-card-text class="pt-6">
                    <v-form ref="supervisorFormRef" v-model="validSupervisorForm">
                        <v-select
                            v-model="supervisorForm.exam_room_offering_id"
                            :items="available_rooms"
                            item-text="room_name"
                            item-value="id"
                            label="Room *"
                            outlined
                            dense
                            :rules="[v => !!v || 'Room is required']"
                        ></v-select>

                        <v-select
                            v-model="supervisorForm.supervisor_id"
                            :items="instructor_list"
                            item-text="display_name"
                            item-value="id"
                            label="Supervisor *"
                            outlined
                            dense
                            :rules="[v => !!v || 'Supervisor is required']"
                        ></v-select>
                    </v-form>
                </v-card-text>

                <v-card-actions class="pb-4 justify-center">
                    <v-btn color="grey" text @click="linkSupervisorFormDialog = false">Cancel</v-btn>
                    <v-btn color="primary" class="px-6" :disabled="!validSupervisorForm" type="button" @click.prevent="handleSupervisorSubmit">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Mark Student Attendance -->
        <v-dialog v-model="markAttendanceDialog" max-width="1500px" persistent>
            <v-card class="pa-4">
                <v-card-title class="headline justify-space-between align-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
                    <span>Mark Student Attendance</span>
                    <v-btn icon @click="closeMarkAttendanceDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-0">
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="3" md="3">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="exam_plan" item-value="id"
                                :items="exam_plan_list" item-text="plan_name" label="Exam Plan" outlined
                                persistent-hint hint="Please Select Exam Plan" @change="getExamPlanData()"/>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="conduct_type" item-value="id"
                                :items="conduct_type_list" item-text="conduct_type" label="Exam Conduct Type" outlined persistent-hint
                                hint="Please Select Exam Conduct Type" />
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="stream" item-value="id"
                                :items="stream_list" item-text="stream_name" label="Stream" outlined persistent-hint
                                hint="Please Select Stream" />
                        </v-col>
                        <v-col cols="12" sm="3" md="3" v-if="exam_plan">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="standard" item-value="id"
                                :items="standard_list" item-text="standard" label="Standard" outlined persistent-hint
                                hint="Please Select Standard" @change="getSubjects()"/>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" v-if="standard">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="subject" item-value="id"
                                :items="std_subjects_list" item-text="subject_name" label="Subject" outlined persistent-hint
                                hint="Please Select Subject" />
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="room" item-value="room_id"
                                :items="room_list" item-text="room_no" label="Room" outlined persistent-hint
                                hint="Please Select Room" @change="getStudentAndSupervisorList()"/>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" v-if="standard">
                            <v-icon color="error"></v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="student" item-value="id"
                                :items="student_list" item-text="name" label="Student" outlined persistent-hint
                                hint="Please Select Student" />
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-icon color="error"></v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="supervisor" item-value="id"
                                :items="supervisor_list" item-text="name" label="Supervisor" outlined persistent-hint
                                hint="Please Select Supervisor" />
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="auto" class="pt-0 mb-5 ml-9">
                            <v-btn color="primary" type="button" @click.prevent="getStudentAttendanceList()" small> Fetch </v-btn>
                        </v-col>
                    </v-row>

                    <v-divider class="my-3"></v-divider>

                    <v-row dense align="center" class="mb-3" v-if="student_attendance_list.length > 0">
                        <v-col cols="12" sm="3" class="d-flex align-center">
                            <v-btn rounded small color="success" outlined :loading="attendanceLoader" @click="exportAttendanceExcel">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export Excel
                            </v-btn>

                             <v-btn rounded color="error" outlined small class="ml-2" @click="exportToPDF">
                                <v-icon left color="error">mdi-file-pdf-box</v-icon>
                                Export PDF
                            </v-btn>
                        </v-col>

                        <v-spacer></v-spacer>

                        <v-col cols="12" sm="4">
                            <v-text-field 
                                v-model="attendanceSearch" 
                                append-icon="mdi-magnify" 
                                label="Search Attendance" 
                                single-line 
                                hide-details 
                                dense 
                                outlined 
                            />
                        </v-col>
                    </v-row>

                    <v-data-table
                        :headers="studentTableHeaders"
                        :items="student_attendance_list"
                        :loading="dialogLoader"
                        :search="attendanceSearch"
                        dense
                        class="elevation-1"
                        v-if="student_attendance_list.length > 0"
                    >
                        <template v-slot:item.srno="{ item, index }">
                            {{ student_attendance_list.indexOf(item) + 1 }}
                        </template>

                        <template v-slot:header.is_absent="{ header }">
                            <div class="d-flex align-center">
                                <v-checkbox
                                    v-model="selectAllAbsent"
                                    hide-details
                                    dense
                                    class="ma-0 pa-0"
                                    @change="toggleSelectAllAbsent"
                                ></v-checkbox>
                                <span class="ml-1">Is Absent?</span>
                            </div>
                        </template>

                        <template v-slot:item.is_absent="{ item }">
                            <v-checkbox
                                v-model="item.is_absent"
                                dense
                                hide-details
                                class="ma-0 pa-0 d-inline-flex"
                                color="error"
                                @change="checkSelectAllState"
                            ></v-checkbox>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions class="justify-center pa-0 mt-4" v-if="student_attendance_list.length > 0">
                    <v-btn color="grey" text small @click="markAttendanceDialog = false">Close</v-btn>
                    <v-btn color="success" small :loading="dialogLoader" type="button" @click.prevent="saveAttendance">Save Attendance</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Add Exam Schedule -->
        <v-dialog v-model="addScheduleDialog" max-width="500px" persistent>
    <v-card class="pa-4">
        <v-card-title class="headline justify-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
            Add Exam Schedule
        </v-card-title>
        <v-card-text class="pa-0">
            <v-form ref="addScheduleForm" v-model="validForm">
                <div class="mb-1 font-weight-bold">Session No <span class="red--text">*</span></div>
                <v-text-field 
                    v-model="newSchedule.session_number" 
                    :rules="[v => !!v || 'Session No is required']" 
                    outlined dense hide-details="auto" class="mb-3"
                ></v-text-field>

                <div class="mb-1 font-weight-bold">Exam Date <span class="red--text">*</span></div>
                <v-text-field 
                    v-model="newSchedule.exam_date" 
                    type="date" 
                    :rules="[v => !!v || 'Exam Date is required']" 
                    outlined dense hide-details="auto" class="mb-3"
                    @change="onAddDateChange"
                ></v-text-field>

                <div class="mb-1 font-weight-bold">Day</div>
                <v-text-field
                    v-model="newSchedule.day"
                    placeholder="Day"
                    readonly
                    disabled
                    outlined
                    dense
                    hide-details
                    class="mb-3 bg-light"
                ></v-text-field>

                <div class="mb-1 font-weight-bold">Slot No <span class="red--text">*</span></div>
                <div class="d-flex align-center mb-3">
                    <v-select 
                        v-model="newSchedule.slot_no" 
                        :items="slotsList" 
                        item-text="name" 
                        item-value="id" 
                        label="Select Slot" 
                        :rules="[v => !!v || 'Slot is required']" 
                        outlined dense hide-details="auto"
                        @change="onSlotChange"
                    ></v-select>
                    <v-btn icon color="black" class="ml-1"><v-icon>mdi-plus-circle</v-icon></v-btn>
                </div>

                <div class="mb-1 font-weight-bold">From Time</div>
                <v-text-field
                    v-model="newSchedule.from_time"
                    placeholder="From Time"
                    append-icon="mdi-clock-time-four-outline"
                    readonly
                    disabled
                    outlined
                    dense
                    hide-details
                    class="mb-3 bg-light"
                ></v-text-field>

                <div class="mb-1 font-weight-bold">To Time</div>
                <v-text-field
                    v-model="newSchedule.to_time"
                    placeholder="To Time"
                    append-icon="mdi-clock-time-four-outline"
                    readonly
                    disabled
                    outlined
                    dense
                    hide-details
                    class="mb-3 bg-light"
                ></v-text-field>

                <div class="mb-1 font-weight-bold">Stream <span class="red--text">*</span></div>
                <div class="d-flex flex-wrap align-center mb-3">
                    <v-checkbox 
                        v-for="stream in streamsList" 
                        :key="'add_stream_' + stream.id" 
                        v-model="newSchedule.streams" 
                        :label="stream.name" 
                        :value="stream.id" 
                        hide-details dense class="ma-0 mr-3 pa-0 mb-1"
                    ></v-checkbox>
                </div>

                <div class="mb-1 font-weight-bold">Standard <span class="red--text">*</span></div>
                <div class="d-flex flex-wrap align-center mb-4">
                    <v-checkbox 
                        v-for="std in standardsList" 
                        :key="'add_std_' + std.id" 
                        v-model="newSchedule.standards" 
                        :label="std.name" 
                        :value="std.id" 
                        hide-details dense class="ma-0 mr-3 pa-0 mb-1"
                    ></v-checkbox>
                </div>
            </v-form>
        </v-card-text>
        <v-card-actions class="justify-center pa-0">
            <v-btn color="primary" small type="button" @click.prevent="saveExamSchedule">Save</v-btn>
            <v-btn color="grey" text small @click="addScheduleDialog = false">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

       <v-dialog v-model="linkStandardStreamDialog" max-width="500px" persistent>
    <v-card class="pa-4 text-center">
        <v-card-title class="headline justify-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
            Link Standard & Stream
        </v-card-title>
        <v-card-text class="pa-0 mb-4 text-left">
            
            <div v-if="alreadySelectedStandardsNames.length || alreadySelectedStreamsNames.length" class="mb-4 pa-3 border-box bg-light">
                <div class="text-subtitle-2 font-weight-bold grey--text text--dark-2 mb-1">
                    Currently Linked Items:
                </div>
                
                <div class="mb-2">
                    <span class="caption font-weight-bold grey--text text--dark-1">Standards: </span>
                    <v-chip 
                        v-for="(stdName, idx) in alreadySelectedStandardsNames" 
                        :key="'chip_std_' + idx"
                        x-small 
                        color="primary" 
                        outlined 
                        class="mr-1 mb-1 font-weight-medium"
                    >
                        {{ stdName }}
                    </v-chip>
                    <span v-if="!alreadySelectedStandardsNames.length" class="caption grey--text">None</span>
                </div>

                <div>
                    <span class="caption font-weight-bold grey--text text--dark-1">Streams: </span>
                    <v-chip 
                        v-for="(streamName, idx) in alreadySelectedStreamsNames" 
                        :key="'chip_stream_' + idx"
                        x-small 
                        color="primary" 
                        outlined 
                        class="mr-1 mb-1 font-weight-medium"
                    >
                        {{ streamName }}
                    </v-chip>
                    <span v-if="!alreadySelectedStreamsNames.length" class="caption grey--text">None</span>
                </div>
            </div>

            <v-divider v-if="alreadySelectedStandardsNames.length || alreadySelectedStreamsNames.length" class="mb-4"></v-divider>

            <div class="mb-1 font-weight-bold grey--text text--dark-2">
                Select Standard <span class="red--text">*</span>
            </div>
            <div class="d-flex flex-wrap align-center px-2 mb-4 border-box">
                <v-checkbox 
                    v-for="std in availableStandardsList" 
                    :key="'link_std_' + std.id" 
                    v-model="selectedStandards" 
                    :label="std.name" 
                    :value="std.id" 
                    hide-details 
                    dense 
                    class="ma-0 pa-0 mb-2 mr-4"
                ></v-checkbox>
                <div v-if="!availableStandardsList.length" class="text-caption grey--text">
                    {{ standardsList.length ? 'All standards are already selected.' : 'No standards available.' }}
                </div>
            </div>

            <v-divider class="mb-3"></v-divider>

            <div class="mb-1 font-weight-bold grey--text text--dark-2">
                Select Stream <span class="red--text">*</span>
            </div>
            <div class="d-flex flex-wrap align-center px-2 mb-2 border-box">
                <v-checkbox 
                    v-for="stream in availableStreamsList" 
                    :key="'link_stream_' + stream.id" 
                    v-model="selectedStreams" 
                    :label="stream.name" 
                    :value="stream.id" 
                    hide-details 
                    dense 
                    class="ma-0 pa-0 mb-2 mr-4"
                ></v-checkbox>
                <div v-if="!availableStreamsList.length" class="text-caption grey--text">
                    {{ streamsList.length ? 'All streams are already selected.' : 'No streams available.' }}
                </div>
            </div>
        </v-card-text>

        <v-card-actions class="justify-center pa-0">
            <v-btn color="primary" small type="button" @click.prevent="saveLinkedStandardsAndStreams">Save</v-btn>
            <v-btn color="grey" text small @click="linkStandardStreamDialog = false">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

        <!-- Edit Schedule Dialog -->
        <v-dialog v-model="editScheduleDialog" max-width="500px" persistent>
            <v-card class="pa-4">
                <v-card-title class="headline justify-center font-weight-bold grey--text text--dark-2 pa-0 mb-4">
                    Edit Exam Schedule
                </v-card-title>
                
                <v-card-text class="pa-0">
                    <v-form ref="editScheduleForm" v-model="validEditForm">
                        <!-- Read-Only Details -->
                        <div class="mb-1 font-weight-bold">Session No</div>
                        <v-text-field
                            v-model="editSchedule.session_number"
                            readonly
                            disabled
                            outlined
                            dense
                            hide-details
                            class="mb-3 bg-light"
                        ></v-text-field>

                        <div class="mb-1 font-weight-bold">Day</div>
                        <v-text-field
                            v-model="editSchedule.day"
                            readonly
                            disabled
                            outlined
                            dense
                            hide-details
                            class="mb-3 bg-light"
                        ></v-text-field>

                        <div class="mb-1 font-weight-bold">Standard</div>
                        <v-text-field
                            v-model="editSchedule.standards_display"
                            readonly
                            disabled
                            outlined
                            dense
                            hide-details
                            class="mb-3 bg-light"
                        ></v-text-field>

                        <div class="mb-1 font-weight-bold">Stream</div>
                        <v-text-field
                            v-model="editSchedule.streams_display"
                            readonly
                            disabled
                            outlined
                            dense
                            hide-details
                            class="mb-3 bg-light"
                        ></v-text-field>

                        <v-divider class="my-4"></v-divider>

                        <!-- Editable Fields -->
                        <div class="mb-1 font-weight-bold">Exam Date <span class="red--text">*</span></div>
                        <v-text-field 
                            v-model="editSchedule.exam_date" 
                            type="date" 
                            :rules="[v => !!v || 'Exam Date is required']" 
                            outlined 
                            dense 
                            hide-details="auto" 
                            class="mb-3"
                            @change="onEditDateChange"
                        ></v-text-field>

                        <div class="mb-1 font-weight-bold">Slot No <span class="red--text">*</span></div>
                        <v-select 
                            v-model="editSchedule.slot_no" 
                            :items="slotsList" 
                            item-text="name" 
                            item-value="id" 
                            label="Select Slot" 
                            :rules="[v => !!v || 'Slot is required']" 
                            outlined 
                            dense 
                            hide-details="auto"
                        ></v-select>
                    </v-form>
                </v-card-text>

                <v-card-actions class="justify-center pa-0 mt-4">
                    <v-btn color="primary" small type="button" @click.prevent="updateExamSchedule">Save</v-btn>
                    <v-btn color="grey" text small @click="editScheduleDialog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";

export default {
    components: {
        Breadcrumbs,
    },

    data: () => ({
        valid: false,
        validForm: false,
        overlay: false,
        dialogLoader: false,
        snackbar_msg: "",
        loader: false,
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        exam_plan: "",
        conduct_type: "",
        stream: "",
        standard: "",
        subject: "",
        room: "",
        student: "",
        supervisor: "",

        fromTimeMenu: false,
        toTimeMenu: false,
        addScheduleDialog: false,
        linkStandardStreamDialog: false,
        markAttendanceDialog: false,
        selectAllAbsent: false,
        selectedRowItem: null,
        seating_dailog: false,
        aloocation_dailog: false,
        exam_sch_standard_list: [],
        exam_sch_stream_list: [],
        exam_sch_div_off_list: [],
        exam_sch_room_list: [],
        exam_sch_std: null,
        exam_sch_str: null,
        exam_sch_div: null,
        exam_sch_room: null,
        selected_exam_room: [],
        sortval1: "Division",
        sortval2: "RollNo",
        benchtype: "All",
        flush_radio: "Generate New",
        exam_dt_sche_id: null,
        ay_id: null,
        allocation_not_done_list: [],
        subjectsDialog: false,
        linkSubjectFormDialog: false,
        subjectLoader: false,
        subjectSearch: "",
        active_detailed_schedule_id: null,
        editedSubjectId: null,
        validSubjectForm: false,

        subject_schedule_data: {},
        linked_subjects: [],
        master_conduct_types: [],
        master_streams: [],
        master_standards: [],
        master_subjects: [],

        newSubject: {
            exam_conduct_type_id: null,
            stream_id: null,
            standard_id: null,
            course_offering_id: null
        },

        subjectHeaders: [
            { text: "S.No", align: "center", value: "sno", sortable: false },
            { text: "Subject Code", align: "center", value: "course_code" },
            { text: "Subject Name", align: "center", value: "course_name" },
            { text: "Standard", align: "center", value: "standard" },
            { text: "Stream", align: "center", value: "stream" },
            { text: "Exam Conduct Type", align: "center", value: "exam_conduct_type" },
            { text: "Action", align: "center", value: "action", sortable: false }
        ],

        // --- ROOM MODAL STATE ---
        roomsDialog: false,
        room_schedule_data: {},
        master_rooms: [],
        selected_rooms: [],

        // --- SUPERVISOR MODAL STATE ---
        supervisorDialog: false,
        linkSupervisorFormDialog: false,
        validSupervisorForm: false,
        supervisor_schedule_data: {},
        linked_supervisors: [],
        available_rooms: [],
        instructor_list: [],

        supervisorHeaders: [
            { text: "S.No", value: "s_no", align: "center", sortable: false },
            { text: "Room No", value: "room_name", align: "center" },
            { text: "Supervisor", value: "supervisor_name", align: "center" },
            { text: "Action", value: "actions", align: "center", sortable: false }
        ],
        supervisorSearch:"",
        supervisorLoader:false,

        supervisorForm: {
            id: null,
            exam_room_offering_id: null,
            supervisor_id: null
        },

        filters: {
            standard: null,
            stream: null,
            subject: null,
            room: null,
            division: null
        },

        filterOptions: {
            standards: [],
            streams: [],
            subjects: [],
            rooms: [],
            divisions: []
        },

        studentList: [],
        studentTableHeaders: [
            { text: "S.No", value: "srno", align: "center" },
            { text: "Is Absent?", value: "is_absent", align: "left" },
            { text: "PRN", value: "prn", align: "left" },
            { text: "Roll No", value: "rollno", align: "left" },
            { text: "Student Name", value: "student_name", align: "left" },
            { text: "Exam Day", value: "exam_day", align: "left" },
            { text: "Slot No", value: "slot_number", align: "left" },
            { text: "From Time", value: "from_time", align: "left" },
            { text: "To Time", value: "to_time", align: "left" },
            { text: "Subject Code", value: "subject_code", align: "left" },
            { text: "Subject Name", value: "subject_name", align: "left" },
            { text: "Conduct Type", value: "conduct_type", align: "left" },
            { text: "Room No", value: "room_number", align: "left" },
            { text: "Bench No", value: "benchnumber", align: "left" },
            { text: "Bench Side", value: "bench_side", align: "left" },
            { text: "Supervisor", value: "supervisor_name", align: "left" },
            { text: "Standard", value: "standard_name", align: "center" },
            { text: "Division", value: "division", align: "center" },
            { text: "Stream", value: "stream_name", align: "center" },
        ],
        attendanceSearch: "",
        attendanceLoader: false,

        stepsList: [
            { label: "Slots Added", key: "step1" },
            { label: "Exam Schedule Added", key: "step2" },
            { label: "Subjectwise Schedule Generated", key: "step3" },
            { label: "Assigned Bench Side", key: "step4" },
            { label: "Offered Room", key: "step5" },
            { label: "Offered Benches", key: "step6" },
            { label: "Rooms Linked to Exam Slot", key: "step7" },
            { label: "Generated Seating Arrangement", key: "step8" }
        ],

        progressStatus: {
            step1: false,
            step2: false,
            step3: false,
            step4: false,
            step5: false,
            step6: false,
            step7: false,
            step8: false
        },

        streamsList: [],
        standardsList: [],
        daysList: [],
        slotsList: [],
        selectedStreams: [],
        selectedStandards: [],
        savedStandards: [], 
        savedStreams: [],
        newSchedule: {
            session_number: '',
            exam_date: '',
            day: null,
            slot_no: null,
            from_time: null,
            to_time: null,
            streams: [],
            standards: []
        },

        subject_list: [],
        exam_plan_list: [],
        room_list: [],
        conduct_type_list: [],
        stream_list: [],
        standard_list: [],
        student_list: [],
        supervisor_list: [],
        student_attendance_list: [],

        editScheduleDialog: false,
        validEditForm: false,
        editSchedule: {
            id: null,
            session_number: '',
            day: '',
            standards_display: '',
            streams_display: '',
            exam_date: '',
            slot_no: null
        },

        headers: [
            { text: "S.No", align: "center", value: "sno", sortable: false },
            { text: "Session No", align: "center", value: "session_number" },
            { text: "Exam Date", align: "center", value: "exam_date" },
            { text: "Day", align: "center", value: "day" },
            { text: "Slot No", align: "center", value: "slot_no" },
            { text: "From Time", align: "center", value: "from_time" },
            { text: "To Time", align: "center", value: "to_time" },
            { text: "Standard & Stream", align: "center", value: "standards_streams", sortable: false },
            { text: "Subjects", align: "center", value: "subjects_count" },
            { text: "Link Rooms", align: "center", value: "link_rooms_count" },
            { text: "Link Supervisor", align: "center", value: "link_supervisor_count" },
            { text: "Mark Attendance", value: "mark_attendance", align: "center", sortable: false },
            { text: "Students", align: "center", value: "total_students" },
            { text: "Total Seats", align: "center", value: "total_seats" },
            { text: "Alloted Seats", align: "center", value: "allotted_seats" },
            { text: "Available Seats", align: "center", value: "available_seats" },
            { text: "Seating Arrangement", align: "center", value: "seating_arrangement", sortable: false },
            // { text: "Room Allotment Report", align: "center", value: "room_allotment_report", sortable: false },
            // { text: "Student Attendance Report", align: "center", value: "student_attendance_report", sortable: false },
            { text: "Action", align: "center", value: "action", sortable: false },
        ],

        exam_plan_data: {},
        exam_plan_details: [],
        std_subjects_list: [],
        division_data :[],
        stream:null,
        std:null,
        div:null,
        dialog_generate_common_seating:false,     

    }),

    computed: {
        completedStepsCount() {
            if (!this.progressStatus) return 0;
            return Object.values(this.progressStatus).filter(Boolean).length;
        },
        getSelectedRoomNames() {
            return (this.master_rooms || [])
                .filter(room => (this.selected_rooms || []).includes(room.id))
                .map(room => room.room_name);
        },
        availableStandardsList() {
            const saved = this.savedStandards || [];
            return (this.standardsList || []).filter(std => !saved.includes(std.id));
        },
        availableStreamsList() {
            return this.streamsList || [];
        },
        alreadySelectedStandardsNames() {
            const saved = this.savedStandards || [];
            return (this.standardsList || [])
                .filter(std => saved.includes(std.id))
                .map(std => std.name);
        },
        alreadySelectedStreamsNames() {
            const saved = this.savedStreams || [];
            return (this.streamsList || [])
                .filter(stream => saved.includes(stream.id))
                .map(stream => stream.name);
        },
        canGenerateSeating() {
            return !!(this.exam_plan_data.is_approved && !this.exam_plan_data.is_seating_freezed);
        },
        filteredSupervisors() {
            if (!this.supervisorSearch) {
                return this.linked_supervisors || [];
            }
            const searchKey = this.supervisorSearch.toLowerCase();
            return (this.linked_supervisors || []).filter((item) => {
                const roomName = (item.room_name || "").toString().toLowerCase();
                const supervisorName = (item.supervisor_name || "").toString().toLowerCase();
                return roomName.includes(searchKey) || supervisorName.includes(searchKey);
            });
        },
        filteredMasterSubjects() {
            return (this.master_subjects || []).filter(
                subject => subject.std === this.newSubject.standard_id
            );
        }
    },

    methods: {
        openSeatingArrangement(examPlanId) {
            const id = examPlanId || this.exam_plan_data.id || this.exam_plan;

            if (!id) {
                this.showSnackbar("#b71c1c", "Exam Plan ID not found.");
                return;
            }

           localStorage.setItem("exam_plan",id)
           const routeData = this.$router.resolve({
                name: "seating-arrangement-report"
            });

            window.open(routeData.href, "_blank");
        },
        formatDate(dateStr) {
            if (!dateStr) return "-";
            
            const parts = dateStr.split(/[\/-]/);
            let date;
            
            if (parts.length === 3 && parts[0].length === 2 && parts[2].length === 4) {
                date = new Date(parts[2], parts[1] - 1, parts[0]);
            } else {
                date = new Date(dateStr);
            }

            return isNaN(date.getTime())
                ? dateStr
                : date.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric"
                });
        },

        formatList(arr) {
            if (!arr || !arr.length) return "-";
            return arr.map(item => typeof item === 'object' ? item.name : item).filter(Boolean).join(", ");
        },

        formatStandards(arr) {
            if (!arr || !arr.length) return "-";
            return arr.map(item => typeof item === 'object' ? item.standard : item).filter(Boolean).join(", ");
        },

        downloadFile() {
            this.loader = true;

            const excelData = this.exam_plan_details.map((item, index) => ({
                "S.No": index + 1,
                "Session No": item.session_number,
                "Exam Date": item.exam_date,
                "Day": item.day,
                "Slot No": item.slot_no,
                "From Time": item.from_time,
                "To Time": item.to_time,
                "Standard": this.formatStandards(item.standards),
                "Stream": this.formatList(item.streams),
                "Subjects": item.subjects_count || 0,
                "Link Rooms": item.link_rooms_count || 0,
                "Link Supervisor": item.link_supervisor_count || 0,
                "Attendance": item.attendance_ratio || 0,
                "Students": item.total_students || 0,
                "Total Seats": item.total_seats || 0,
                "Alloted Seats": item.alloted_seats || 0,
                "Available Seats": item.available_seats || 0
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Exam Plan Details"
            );

            XLSX.writeFile(workbook, "ExamPlanDetails.xlsx");
            this.loader = false;
        },

        onLoad() {
            if (!this.exam_plan) {
                this.showSnackbar("#b71c1c", "Exam Plan Not Found");
                return;
            }

            this.overlay = true;
            const data = {
                exam_plan: this.exam_plan
            };

            axios
                .post("/SeatingArrangement/getExamPlanDetails", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.exam_plan_data = res.data.exam_plan_data || {};
                        this.exam_plan_details = res.data.exam_plan_details || [];
                        this.subject_list = res.data.master_subject_list || [];

                        if (res.data.exam_plan_progress) {
                            this.progressStatus = {
                                step1: !!res.data.exam_plan_progress.step1,
                                step2: !!res.data.exam_plan_progress.step2,
                                step3: !!res.data.exam_plan_progress.step3,
                                step4: !!res.data.exam_plan_progress.step4,
                                step5: !!res.data.exam_plan_progress.step5,
                                step6: !!res.data.exam_plan_progress.step6,
                                step7: !!res.data.exam_plan_progress.step7,
                                step8: !!res.data.exam_plan_progress.step8
                            };
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    console.error(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        
        async proceedGenerateCommonSeatingArrangement(){
           
            const data = {
                ay_id:this.ay_id,
                exam_plan:this.exam_plan,
                st_id:this.std,
                stream_id:this.stream,
                div_id:this.div,
                sortval1: this.sortval1,
                sortval2: this.sortval2,
                benchtype: this.benchtype,
                flush_radio:this.flush_radio
            }
             this.loader= true,
            axios
                .post("/SeatingArrangement/proceedGenerateCommonSeatingArrangement", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#2e7d32", "Exam Seating Arrangement saved successfully");
                        this.allocation_not_done_list = res.data.allocation_not_done_list
                        if(this.allocation_not_done_list!=''){
                            this.aloocation_dailog = true
                        }
                        this.onLoad();
                        this.dialog_generate_common_seating = false
                        this.loader= false
                    }
                    else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                        this.dialog_generate_common_seating = false
                        this.loader= false
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.dialog_generate_common_seating = false
                        this.loader= false
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    this.dialog_generate_common_seating = false
                    this.loader= false
                })
                .finally(() => {
                    this.std = null,
                    this.stream = null,
                    this.div = null,
                    this.loader= false
                    this.sortval1= "Division",  // default selection
                    this.sortval2= "RollNo",   // default checked option
                    this.benchtype= "All",   // default checked option
                    this.flush_radio="Generate New"
                });
        },

        async proceedGenerateSeatingArrangement(){
            const data = {
                ay_id: this.ay_id,
                exam_dt_sche_id: this.exam_dt_sche_id,
                st_id: this.exam_sch_std,
                stream_id: this.exam_sch_str,
                div_id: this.exam_sch_div,
                room_id: this.exam_sch_room,
                sortval1: this.sortval1,
                sortval2: this.sortval2,
                benchtype: this.benchtype,
                flush_radio:this.flush_radio
            };
            this.loader = true;
            axios
                .post("/SeatingArrangement/proceedGenerateSeatingArrangement", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#2e7d32", "Exam Seating Arrangement saved successfully");
                        this.allocation_not_done_list = res.data.allocation_not_done_list;
                        if (this.allocation_not_done_list && this.allocation_not_done_list.length > 0) {
                            this.aloocation_dailog = true;
                        }
                        this.onLoad();
                        this.seating_dailog = false;
                        this.loader = false;
                    }
                    else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                        this.seating_dailog = false;
                        this.loader = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.seating_dailog = false;
                        this.loader = false;
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    this.seating_dailog = false;
                    this.loader = false;
                })
                .finally(() => {
                    this.exam_sch_std = null;
                    this.exam_sch_str = null;
                    this.exam_sch_div = null;
                    this.exam_sch_room = null;
                    this.loader = false;
                    this.sortval1= "Division",  // default selection
                    this.sortval2= "RollNo",   // default checked option
                    this.benchtype= "All",   // default checked option
                    this.flush_radio="Generate New"
                });
        },

        async proceedGeneratePersonalizedTimeTable(item){
            this.exam_dt_sche_id = item.id;
            const data = {
                exam_dt_sche_id: item.id,
                ay_id: this.ay_id
            };
            axios
                .post("/SeatingArrangement/getExamDetailedScheduledDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.exam_sch_standard_list = res.data.standard_list || [];
                        this.exam_sch_stream_list = res.data.stream_list || [];
                        this.exam_sch_div_off_list = res.data.div_off_list || [];
                        this.exam_sch_room_list = res.data.room_list || [];
                        this.seating_dailog = true;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.fmsg || "Something went wrong...");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        },

        openSubjectsModal(item) {
            if (!item || !item.id) {
                this.showSnackbar("#b71c1c", "Schedule details not found");
                return;
            }
            this.active_detailed_schedule_id = item.id;
            this.subjectsDialog = true;
            this.loadSubjectScheduleDetails(item.id);
        },

        closeSubjectsModal() {
            this.subjectsDialog = false;
            this.active_detailed_schedule_id = null;
            this.subject_schedule_data = {};
            this.linked_subjects = [];
            this.onLoad();
        },

        loadSubjectScheduleDetails(scheduleId) {
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getSubjectScheduleDetails", {
                    detailed_schedule_id: scheduleId
                })
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.subject_schedule_data = res.data.schedule_data || {};
                        this.linked_subjects = res.data.linked_subjects || [];

                        this.master_conduct_types = res.data.master_conduct_types || [];
                        this.master_streams = res.data.master_streams || [];
                        this.master_standards = res.data.master_standards || [];
                        this.master_subjects = res.data.master_subjects || [];
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to fetch details");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showSnackbar("#b71c1c", "Error fetching subject details");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        updateExamPlanStatuses() {
            this.overlay = true;
            const payload = {
                id: this.exam_plan_data.id,
                is_approved: this.exam_plan_data.is_approved,
                is_current: this.exam_plan_data.is_current,
                is_seating_freezed: this.exam_plan_data.is_seating_freezed,
                is_supervisor_required: this.exam_plan_data.is_supervisor_required,
                allow_auto_bench_allocation: this.exam_plan_data.allow_auto_bench_allocation
            };
            axios
                .post("/seatingArrangement/updateExamPlanStatuses", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Exam plan statuses updated successfully");
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to update exam plan statuses");
                    }
                })
                .catch((error) => {
                    console.error("Save Error:", error);
                    this.showSnackbar("#b71c1c", "Error updating exam plan statuses");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        openAddSubjectModal() {
            this.editedSubjectId = null;
            this.resetSubjectForm();
            this.linkSubjectFormDialog = true;
        },

        editSubjectItem(item) {
            this.editedSubjectId = item.id;
            this.newSubject = {
                exam_conduct_type_id: item.exam_conduct_type_id || null,
                stream_id: item.stream_id || null,
                standard_id: item.standard_id || null,
                course_offering_id: item.course_offering_id || null
            };
            this.linkSubjectFormDialog = true;
        },

        closeSubjectFormModal() {
            this.linkSubjectFormDialog = false;
            this.editedSubjectId = null;
            this.resetSubjectForm();
        },

        resetSubjectForm() {
            this.newSubject = {
                exam_conduct_type_id: null,
                stream_id: null,
                standard_id: null,
                course_offering_id: null
            };
        },

        validateSubjectForm() {
            if (
                !this.newSubject.exam_conduct_type_id ||
                !this.newSubject.stream_id ||
                !this.newSubject.standard_id ||
                !this.newSubject.course_offering_id
            ) {
                this.showSnackbar("#b71c1c", "Please fill all required fields");
                return false;
            }
            return true;
        },

        saveCoursewiseSchedule() {
            if (!this.validateSubjectForm()) return;

            this.overlay = true;
            const payload = {
                detailed_schedule_id: this.active_detailed_schedule_id,
                exam_conduct_type_id: this.newSubject.exam_conduct_type_id,
                stream_id: this.newSubject.stream_id,
                standard_id: this.newSubject.standard_id,
                course_offering_id: this.newSubject.course_offering_id
            };

            axios
                .post("/SeatingArrangement/saveCoursewiseSchedule", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Subject linked successfully");
                        this.closeSubjectFormModal();
                        this.loadSubjectScheduleDetails(this.active_detailed_schedule_id);
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to save subject");
                    }
                })
                .catch((error) => {
                    console.error("Save Error:", error);
                    this.showSnackbar("#b71c1c", "Error saving subject link");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        updateCoursewiseSchedule() {
            if (!this.validateSubjectForm()) return;

            this.overlay = true;
            const payload = {
                id: Number(this.editedSubjectId),
                detailed_schedule_id: Number(this.active_detailed_schedule_id),
                exam_conduct_type_id: Number(this.newSubject.exam_conduct_type_id),
                stream_id: Number(this.newSubject.stream_id),
                standard_id: Number(this.newSubject.standard_id),
                course_offering_id: Number(this.newSubject.course_offering_id)
            };

            axios
                .post("/SeatingArrangement/editCoursewiseSchedule", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Subject updated successfully");
                        this.closeSubjectFormModal();
                        this.loadSubjectScheduleDetails(this.active_detailed_schedule_id);
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to update subject");
                    }
                })
                .catch((error) => {
                    console.error("Update Error:", error);
                    this.showSnackbar("#b71c1c", "Error updating subject");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        confirmDeleteSubject(item) {
            if (confirm("Are you sure want to delete this subject linking")) {
                this.overlay = true;
                axios
                    .post("/SeatingArrangement/deleteCoursewiseSchedule", {
                        id: item.id
                    })
                    .then((res) => {
                        if (res.data.msg === "200") {
                            this.showSnackbar("#2e7d32", res.data.text || "Subject unlinked successfully");
                            this.loadSubjectScheduleDetails(this.active_detailed_schedule_id);
                        } else {
                            this.showSnackbar("#b71c1c", res.data.text || "Failed to delete item");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        this.showSnackbar("#b71c1c", "Error deleting subject schedule");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            }
        },

        exportSubjectsExcel() {
            this.subjectLoader = true;
            const excelData = this.linked_subjects.map((item, index) => ({
                "S.No": index + 1,
                "Subject Code": item.course_code,
                "Subject Name": item.course_name,
                "Standard": item.standard,
                "Stream": item.stream,
                "Exam Conduct Type": item.exam_conduct_type
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Linked Subjects");
            XLSX.writeFile(workbook, "LinkedSubjects.xlsx");
            this.subjectLoader = false;
        },

        exportSupervisorExcel() {
            if (!this.linked_supervisors || !this.linked_supervisors.length) {
                this.showSnackbar("#b71c1c", "No linked supervisor data to export.");
                return;
            }

            this.supervisorLoader = true;
            const excelData = this.linked_supervisors.map((item, index) => ({
                "S.No": index + 1,
                "Room No": item.room_name || "-",
                "Supervisor": item.supervisor_name || "-"
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Linked Supervisors");
            XLSX.writeFile(workbook, "LinkedSupervisors.xlsx");
            this.supervisorLoader = false;
        },

        exportAttendanceExcel() {
            if (!this.student_attendance_list || !this.student_attendance_list.length) {
                this.showSnackbar("#b71c1c", "No attendance data to export.");
                return;
            }

            this.attendanceLoader = true;
            const excelData = this.student_attendance_list.map((item, index) => ({
                "S.No": index + 1,
                "Is Absent?": item.is_absent ? "Yes" : "No",
                "PRN": item.prn || "-",
                "Student Name": item.student_name || "-",
                "Exam Day": item.exam_day || "-",
                "Slot No": item.slot_number || "-",
                "From Time": item.from_time || "-",
                "To Time": item.to_time || "-",
                "Subject Code": item.subject_code || "-",
                "Subject Name": item.subject_name || "-",
                "Conduct Type": item.conduct_type || "-",
                "Room No": item.room_number || "-",
                "Bench No": item.benchnumber || "-",
                "Bench Side": item.bench_side || "-",
                "Supervisor": item.supervisor_name || "-",
                "Standard": item.standard_name || "-",
                "Stream": item.stream_name || "-"
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Student Attendance");
            XLSX.writeFile(workbook, "Student_Attendance_List.xlsx");
            this.attendanceLoader = false;
        },

        exportToPDF() {
            if (!this.student_attendance_list || !this.student_attendance_list.length) {
                this.showSnackbar("#b71c1c", "No data available to export");
                return;
            }

            const printWindow = window.open("", "_blank");

            let html = `
                <html>
                <head>
                    <title>Student Seating Arrangement Report</title>
                    <style>
                        @page {
                            size: A4 landscape;
                            margin: 8mm;
                        }

                        body {
                            font-family: Arial, sans-serif;
                            font-size: 9px;
                            margin: 0;
                        }

                        h2 {
                            text-align: center;
                            margin: 0 0 10px 0;
                            font-size: 16px;
                        }

                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }

                        th, td {
                            border: 1px solid #000;
                            padding: 4px;
                            text-align: left;
                            vertical-align: middle;
                            font-size: 12px;
                        }

                        th {
                            background: #f2f2f2;
                            font-weight: bold;
                            text-align: center;
                        }

                        tr {
                            page-break-inside: avoid;
                        }
                    </style>
                </head>
                <body>

                <h2>Student Attendance Report</h2>

                <table>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Is Absent?</th>
                            <th>PRN</th>
                            <th>Roll No</th>
                            <th>Student Name</th>
                            <th>Exam Day</th>
                            <th>Slot No</th>
                            <th>From Time</th>
                            <th>To Time</th>
                            <th>Subject Code</th>
                            <th>Subject Name</th>
                            <th>Conduct Type</th>
                            <th>Room No</th>
                            <th>Bench No</th>
                            <th>Bench Side</th>
                            <th>Supervisor</th>
                            <th>Standard</th>
                            <th>Division</th>
                            <th>Stream</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            this.student_attendance_list.forEach((item, index) => {
                html += `
                    <tr>
                        <td>${index + 1}</td>
                        <td>${item.is_absent ? "Yes" : "No"}</td>
                        <td>${item.prn || ""}</td>
                        <td>${item.rollno || ""}</td>
                        <td>${item.student_name || ""}</td>
                        <td>${item.exam_day || ""}</td>
                        <td>${item.slot_number || ""}</td>
                        <td>${item.from_time || ""}</td>
                        <td>${item.to_time || ""}</td>
                        <td>${item.subject_code || ""}</td>
                        <td>${item.subject_name || ""}</td>
                        <td>${item.conduct_type || ""}</td>
                        <td>${item.room_number || ""}</td>
                        <td>${item.benchnumber || ""}</td>
                        <td>${item.bench_side || ""}</td>
                        <td>${item.supervisor_name || ""}</td>
                        <td>${item.standard_name || ""}</td>
                        <td>${item.division || ""}</td>
                        <td>${item.stream_name || ""}</td>
                    </tr>
                `;
            });

            html += `
                    </tbody>
                </table>

                </body>
                </html>
            `;

            printWindow.document.open();
            printWindow.document.write(html);
            printWindow.document.close();

            printWindow.onload = function() {
                printWindow.focus();
                printWindow.print();
            };
        },

        openRoomsModal(item) {
            if (!item || !item.id) {
                this.showSnackbar("#b71c1c", "Schedule details not found");
                return;
            }
            this.active_detailed_schedule_id = item.id;
            this.roomsDialog = true;
            
            this.loadRoomScheduleDetails(item.id);
        },

        closeRoomsModal() {
            this.roomsDialog = false;
            this.active_detailed_schedule_id = null;
            this.room_schedule_data = {};
            this.master_rooms = [];
            this.selected_rooms = [];
            this.onLoad();
        },

        loadRoomScheduleDetails(scheduleId) {
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getRoomScheduleDetails", {
                    detailed_schedule_id: Number(scheduleId)
                })
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.room_schedule_data = res.data.schedule_data || {};
                        this.master_rooms = res.data.master_rooms || [];
                        
                        this.selected_rooms = res.data.selected_room_ids || [];
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to fetch room schedule details");
                    }
                })
                .catch((error) => {
                    console.error("Fetch Error:", error);
                    this.showSnackbar("#b71c1c", "Error fetching room schedule details");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        saveRoomSchedule() {
            if (!this.active_detailed_schedule_id) {
                this.showSnackbar("#b71c1c", "Detailed Schedule ID not found");
                return;
            }

            this.overlay = true;
            const payload = {
                detailed_schedule_id: Number(this.active_detailed_schedule_id),
                room_ids: this.selected_rooms
            };

            axios
                .post("/SeatingArrangement/saveRoomSchedule", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Rooms linked successfully");
                        this.closeRoomsModal();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to link rooms");
                    }
                })
                .catch((error) => {
                    console.error("Save Error:", error);
                    this.showSnackbar("#b71c1c", "Error saving room schedule");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        openSupervisorModal(item) {
            if (!item.subjects_count || item.subjects_count === 0) {
                this.showSnackbar("#b71c1c", "Please link subjects first before linking supervisor.");
                return;
            }
            if (!item || !item.id) {
                this.showSnackbar("#b71c1c", "Schedule details not found");
                return;
            }
            this.active_detailed_schedule_id = item.id;
            this.supervisorDialog = true;
            this.loadSupervisorScheduleDetails(item.id);
        },

        closeSupervisorModal() {
            this.supervisorDialog = false;
            this.active_detailed_schedule_id = null;
            this.supervisor_schedule_data = {};
            this.linked_supervisors = [];
            this.onLoad();
        },

        loadSupervisorScheduleDetails(scheduleId) {
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getSupervisorLinkDetails", {
                    detailed_schedule_id: Number(scheduleId)
                })
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.supervisor_schedule_data = res.data.schedule_data || {};
                        this.linked_supervisors = res.data.linked_supervisors || [];
                        this.available_rooms = res.data.available_rooms || [];
                        this.instructor_list = res.data.instructor_list || [];
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to load supervisor details");
                    }
                })
                .catch((error) => {
                    console.error("Fetch Error:", error);
                    this.showSnackbar("#b71c1c", "Error fetching supervisor details");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        openSupervisorFormModal(item) {
            if (item) {
                this.supervisorForm.id = item.id;
                this.supervisorForm.exam_room_offering_id = item.exam_room_offering_id;
                this.supervisorForm.supervisor_id = item.supervisor_id;
            } else {
                this.resetSupervisorForm();
            }
            this.linkSupervisorFormDialog = true;
        },

        resetSupervisorForm() {
            this.supervisorForm = { id: null, exam_room_offering_id: null, supervisor_id: null };
            if (this.$refs.supervisorFormRef) {
                this.$refs.supervisorFormRef.resetValidation();
            }
        },

        handleSupervisorSubmit() {
            if (this.$refs.supervisorFormRef && !this.$refs.supervisorFormRef.validate()) return;

            if (this.supervisorForm.id) {
                this.editSupervisorMapping();
            } else {
                this.saveSupervisorMapping();
            }
        },

        saveSupervisorMapping() {
            this.overlay = true;
            const payload = {
                detailed_schedule_id: Number(this.active_detailed_schedule_id),
                exam_room_offering_id: this.supervisorForm.exam_room_offering_id,
                supervisor_id: this.supervisorForm.supervisor_id
            };

            axios
                .post("/SeatingArrangement/saveSupervisorSchedule", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Supervisor assigned successfully");
                        this.linkSupervisorFormDialog = false;
                        this.resetSupervisorForm();
                        this.loadSupervisorScheduleDetails(this.active_detailed_schedule_id);
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to assign supervisor");
                    }
                })
                .catch((error) => {
                    console.error("Save Error:", error);
                    this.showSnackbar("#b71c1c", "Error assigning supervisor");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        editSupervisorMapping() {
            this.overlay = true;
            const payload = {
                id: this.supervisorForm.id,
                detailed_schedule_id: Number(this.active_detailed_schedule_id),
                exam_room_offering_id: this.supervisorForm.exam_room_offering_id,
                supervisor_id: this.supervisorForm.supervisor_id
            };

            axios
                .post("/SeatingArrangement/editSupervisorSchedule", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Supervisor updated successfully");
                        this.linkSupervisorFormDialog = false;
                        this.resetSupervisorForm();
                        this.loadSupervisorScheduleDetails(this.active_detailed_schedule_id);
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to update supervisor");
                    }
                })
                .catch((error) => {
                    console.error("Edit Error:", error);
                    this.showSnackbar("#b71c1c", "Error updating supervisor");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        deleteSupervisorMapping(id) {
            if (!confirm("Are you sure you want to remove this supervisor?")) return;

            this.overlay = true;
            axios
                .post("/SeatingArrangement/deleteSupervisorSchedule", { id: id })
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Supervisor unlinked successfully");
                        this.loadSupervisorScheduleDetails(this.active_detailed_schedule_id);
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to delete mapping");
                    }
                })
                .catch((error) => {
                    console.error("Delete Error:", error);
                    this.showSnackbar("#b71c1c", "Error deleting mapping");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        toggleSelectAllAbsent(val) {
            if (this.student_attendance_list && this.student_attendance_list.length) {
                this.student_attendance_list.forEach(item => {
                    item.is_absent = !!val;
                });
            }
        },

        checkSelectAllState() {
            if (this.student_attendance_list && this.student_attendance_list.length) {
                this.selectAllAbsent = this.student_attendance_list.every(item => item.is_absent);
            } else {
                this.selectAllAbsent = false;
            }
        },

        saveAttendance() {
            if (!this.student_attendance_list || !this.student_attendance_list.length) {
                this.showSnackbar("#b71c1c", "No student attendance data to save.");
                return;
            }

            this.dialogLoader = true;
            const payload = {
                attendance_data: this.student_attendance_list.map(item => ({
                    seating_id: item.seating_id,
                    is_absent: !!item.is_absent
                }))
            };

            axios.post("/SeatingArrangement/saveStudentAttendance", payload)
                .then(res => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Attendance updated successfully.");
                        this.markAttendanceDialog = false;
                        this.getStudentAttendanceList();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to save attendance.");
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.showSnackbar("#b71c1c", "Something went wrong while saving attendance.");
                })
                .finally(() => {
                    this.dialogLoader = false;
                });
        },

        openAttendanceModal(item) {
            if (!item || !item.id) {
                this.showSnackbar("#b71c1c", "Schedule ID missing");
                return;
            }
            this.selectedRowItem = item;
            this.markAttendanceDialog = true;
            
            this.filters = {
                standard: null,
                stream: null,
                subject: null,
                room: null,
                division: null
            };
            this.getData();
        },

        getData() {
            axios
                .post("/SeatingArrangement/getData")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.exam_plan_list = res.data.exam_plan_list;
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getExamPlanDataSeating() {
            this.stream_list = []
            this.standard_list = []
            this.division_data = []
            const data = {
                exam_plan: this.exam_plan,
            };
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getDataOnExamPlan", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.stream_list = res.data.stream_list;
                        this.standard_list = res.data.standard_list;
                        this.division_data = res.data.division_data;
                        this.dialog_generate_common_seating = true
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getExamPlanData() {
            this.stream_list = []
            this.standard_list = []
            this.division_data = []
            this.conduct_type_list = []
            const data = {
                exam_plan: this.exam_plan,
            };
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getDataOnExamPlan", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.conduct_type_list = res.data.conduct_type_list;
                        this.stream_list = res.data.stream_list;
                        this.standard_list = res.data.standard_list;
                        this.room_list = res.data.room_list;

                        if(this.conduct_type_list.length > 0){
                            this.conduct_type_list = [{ id: "All", conduct_type: "All" }, ...(res.data.conduct_type_list || [])];
                        }
                        if(this.stream_list.length > 0){
                            this.stream_list = [{ id: "All", stream_name: "All" }, ...(res.data.stream_list || [])];
                        }
                        if(this.standard_list.length > 0){
                            this.standard_list = [{ id: "All", standard: "All" }, ...(res.data.standard_list || [])];
                        }
                        if(this.room_list.length > 0){
                            this.room_list = [{ id: "All", room_no: "All" }, ...(res.data.room_list || [])];
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getSubjects() {
            const data = {
                exam_plan: this.exam_plan,
                std: this.standard
            };
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getSubjects", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.std_subjects_list = res.data.subjects_list;

                        if(this.subject_list.length > 0){
                            this.subject_list = [{ id: "All", subject_name: "All" }, ...(res.data.subjects_list || [])];
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getStudentAndSupervisorList() {
            const data = {
                exam_plan: this.exam_plan,
                std: this.standard,
                conduct_type: this.conduct_type,
                stream: this.stream,
                subject: this.subject,
                room: this.room,
            };
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getStudentAndSupervisorList", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.student_list = res.data.students;
                        this.supervisor_list = res.data.supervisors;

                        if(this.student_list.length > 0){
                            this.student_list = [{ id: "All", name: "All" }, ...(res.data.students || [])];
                        }
                        if(this.supervisor_list.length > 0){
                            this.supervisor_list = [{ id: "All", name: "All" }, ...(res.data.supervisors || [])];
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getStudentAttendanceList() {
            const data = {
                exam_plan: this.exam_plan,
                std: this.standard,
                conduct_type: this.conduct_type,
                stream: this.stream,
                subject: this.subject,
                room: this.room,
                student: this.student,
                supervisor: this.supervisor
            };
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getStudentAttendanceList", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.student_attendance_list = res.data.attendance_list;
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        onSlotChange(selectedSlotId) {
            if (!selectedSlotId) {
                this.newSchedule.from_time = null;
                this.newSchedule.to_time = null;
                return;
            }

            const selectedSlot = this.slotsList.find(slot => slot.id === selectedSlotId);

            if (selectedSlot) {
                this.newSchedule.from_time = selectedSlot.from_time || null;
                this.newSchedule.to_time = selectedSlot.to_time || null;
            } else {
                this.newSchedule.from_time = null;
                this.newSchedule.to_time = null;
            }
        },

        getDayFromDate(dateStr) {
            if (!dateStr) return null;
            const [year, month, day] = dateStr.split("-");
            if (!year || !month || !day) return null;
            
            const date = new Date(year, month - 1, day);
            if (isNaN(date.getTime())) return null;

            const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            return days[date.getDay()];
        },

        onAddDateChange() {
            this.newSchedule.day = this.getDayFromDate(this.newSchedule.exam_date);
        },

        onEditDateChange() {
            this.editSchedule.day = this.getDayFromDate(this.editSchedule.exam_date);
        },

        openAddScheduleDialog() {
            const data = {
                examPlan: this.exam_plan_data.id
            };
            this.overlay = true;
            axios.post("/seatingArrangement/getScheduleDropdownData", data)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.streamsList = res.data.streams || [];
                        this.standardsList = res.data.standards || [];
                        this.daysList = res.data.days || [];
                        this.slotsList = res.data.slots || [];

                        this.newSchedule = {
                            session_number: '',
                            exam_date: '',
                            day: null,
                            slot_no: null,
                            from_time: null,
                            to_time: null,
                            streams: [],
                            standards: []
                        };
                        this.addScheduleDialog = true;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to load master options");
                    }
                })
                .catch((err) => {
                    console.error("Error:", err);
                    this.showSnackbar("#b71c1c", "Error fetching master options");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        openLinkStandardStreamModal(item) {
            if (!item || !item.id) {
                this.showSnackbar("#b71c1c", "Please select a schedule row first.");
                return;
            }
            this.selectedRowItem = item; 
            this.overlay = true;

            const payload = {
                detailed_schedule_id: item.id
            };

            axios.post("/seatingArrangement/getStandardsList", payload)
            .then((res) => {
                if (res.data.msg == "200") {
                    this.standardsList = res.data.standards || [];
                    this.streamsList = res.data.streams || [];
                    this.savedStandards = res.data.saved_standards || [];
                    this.savedStreams = res.data.saved_streams || [];
                    this.selectedStandards = [];
                    this.selectedStreams = [];
                    
                    this.linkStandardStreamDialog = true;
                } else {
                    this.showSnackbar("#b71c1c", res.data.text || "Failed to load options");
                }
            })
            .catch((err) => {
                console.error("Error:", err);
                this.showSnackbar("#b71c1c", "Error fetching options");
            })
            .finally(() => {
                this.overlay = false;
            });
        },

        saveExamSchedule() {
            if (!this.$refs.addScheduleForm.validate()) {
                this.showSnackbar("#b71c1c", "Please fill required fields");
                return;
            }
            if (this.newSchedule.streams.length === 0 || this.newSchedule.standards.length === 0) {
                this.showSnackbar("#b71c1c", "Please select at least one Stream and Standard");
                return;
            }

            this.overlay = true;
            const payload = {
                exam_plan_id: this.exam_plan_data.id,
                ...this.newSchedule
            };

            axios.post("/seatingArrangement/saveExamSchedule", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Exam schedule created successfully");
                        this.addScheduleDialog = false;
                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to save exam schedule");
                    }
                })
                .catch((err) => {
                    console.error("Save Error:", err);
                    this.showSnackbar("#b71c1c", "Error saving schedule");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

       saveLinkedStandardsAndStreams() {
            if (!this.selectedStandards.length || !this.selectedStreams.length) {
                this.showSnackbar("#b71c1c", "Please select at least one standard and one stream");
                return;
            }

            this.overlay = true;
            const payload = {
                exam_plan_id: this.exam_plan_data.id || this.exam_plan,
                detailed_schedule_id: this.selectedRowItem.id,
                standards: this.selectedStandards,
                streams: this.selectedStreams
            };

            axios.post("/seatingArrangement/saveLinkedStandardsAndStreams", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Standards and Streams linked successfully");
                        this.linkStandardStreamDialog = false;
                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to link options");
                    }
                })
                .catch((err) => {
                    console.error("Save Error:", err);
                    this.showSnackbar("#b71c1c", "Error saving links");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        viewRoomReport(examPlanId) {
            const id = examPlanId || this.exam_plan_data.id || this.exam_plan;

            if (!id) {
                this.showSnackbar("#b71c1c", "Exam Plan ID not found.");
                return;
            }

           localStorage.setItem("exam_plan_id",id)
           const routeData = this.$router.resolve({
                name: "room-allotment-report"
            });

            window.open(routeData.href, "_blank");
        },

        viewAttendanceReport(examPlanId) {
            const id = examPlanId || this.exam_plan_data.id || this.exam_plan;

            if (!id) {
                this.showSnackbar("#b71c1c", "Exam Plan ID not found.");
                return;
            }

           localStorage.setItem("exam_plan_id",id)
           const routeData = this.$router.resolve({
                name: "all-student-attendance-report"
            });

            window.open(routeData.href, "_blank");
        },

        editItem(item) {
            if (!item || !item.id) {
                this.showSnackbar("#b71c1c", "Invalid schedule row selected");
                return;
            }

            if (!this.slotsList || !this.slotsList.length) {
                this.overlay = true;
                axios.post("/seatingArrangement/getScheduleDropdownData", { examPlan: this.exam_plan_data.id })
                    .then(res => {
                        if (res.data.msg === "200") {
                            this.slotsList = res.data.slots || [];
                        }
                    })
                    .catch(err => console.error(err))
                    .finally(() => { this.overlay = false; });
            }

            this.editSchedule = {
                id: item.id,
                session_number: item.session_number != null ? item.session_number : '-',
                day: item.day || this.getDayFromDate(formattedIsoDate) || '-',
                standards_display: this.formatStandards(item.standards),
                streams_display: this.formatList(item.streams),
                exam_date: this.formatDateToISO(item.exam_date),
                slot_no: item.slot_no || item.slot_id || null
            };

            this.editScheduleDialog = true;
        },

        updateExamSchedule() {
            if (!this.$refs.editScheduleForm.validate()) {
                this.showSnackbar("#b71c1c", "Please fill required fields.");
                return;
            }

            this.overlay = true;
            const payload = {
                id: Number(this.editSchedule.id),
                exam_date: this.editSchedule.exam_date, 
                day: this.editSchedule.day,
                slot_no: Number(this.editSchedule.slot_no)
            };

            axios
                .post("/SeatingArrangement/updateExamSchedule", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#2e7d32", res.data.text || "Exam schedule updated successfully.");
                        this.editScheduleDialog = false;
                        this.onLoad(); 
                    } else {
                        this.showSnackbar("#b71c1c", res.data.text || "Failed to update exam schedule.");
                    }
                })
                .catch((error) => {
                    console.error("Update Error:", error);
                    this.showSnackbar("#b71c1c", "Error updating exam schedule.");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        deleteItem(item) {
            if (!item || !item.id) {
                this.showSnackbar("#b71c1c", "Invalid schedule row selected.");
                return;
            }

            if (confirm("Are you sure you want to delete this schedule? This will permanently delete all linked data")) {
                this.overlay = true;
                
                axios
                    .post("/SeatingArrangement/deleteExamSchedule", { id: Number(item.id) })
                    .then((res) => {
                        if (res.data.msg === "200") {
                            this.showSnackbar("#2e7d32", res.data.text || "Schedule and all related data deleted successfully.");
                            this.onLoad(); 
                        } else {
                            this.showSnackbar("#b71c1c", res.data.text || "Failed to delete schedule.");
                        }
                    })
                    .catch((error) => {
                        console.error("Delete Error:", error);
                        this.showSnackbar("#b71c1c", "Error deleting exam schedule.");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            }
        },

        formatDateToISO(dateStr) {
            if (!dateStr || dateStr === '-') return '';
            
            if (typeof dateStr === 'string' && dateStr.includes('/')) {
                const parts = dateStr.split('/');
                if (parts.length === 3) {
                    const day = parts[0].padStart(2, '0');
                    const month = parts[1].padStart(2, '0');
                    const year = parts[2];
                    return `${year}-${month}-${day}`; 
                }
            }

            const date = new Date(dateStr);
            if (!isNaN(date.getTime())) {
                return date.toISOString().split('T')[0];
            }

            return dateStr;
        },

        closeMarkAttendanceDialog(){
            this.markAttendanceDialog = false; 
            this.student_attendance_list=[];
            this.exam_plan=null;
            this.conduct_type=null;
            this.stream=null;
            this.standard=null;
            this.subject=null;
            this.room=null;
            this.student=null;
            this.supervisor=null
        }
    },

    mounted() {
        this.exam_plan = localStorage.getItem("exam_plan");
        this.ay_id = localStorage.getItem("ay");
        this.onLoad();
    }
};
</script>

<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.min-width-auto {
    min-width: unset !important;
}

.min-height-24 {
    min-height: 24px !important;
}

.progress-card {
    border: 1px solid #1a237e !important;
    background-color: #ffffff;
}

.mytable /deep/ thead th {
    background: #0f2027;
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mytable /deep/ td {
    padding: 12px 10px !important;
    font-size: 13px;
    vertical-align: middle;
}

.simple-exam-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #ffffff;
    text-align: center;
    font-family: Arial, sans-serif;
    border: 1px solid #dcdcdc;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.simple-exam-table th {
    background-color: #f2f2f2;
    color: #333333;
    font-weight: 600;
    font-size: 13px;
    padding: 10px 8px;
    border: 1px solid #dcdcdc;
    white-space: nowrap;
}

.simple-exam-table td {
    padding: 8px 10px;
    font-size: 13px;
    color: #444444;
    border: 1px solid #dcdcdc;
    vertical-align: middle;
}

.simple-exam-table tbody tr:hover {
    background-color: #f9f9f9;
}

.simple-exam-table /deep/ .v-input--selection-controls {
    margin-top: 0 !important;
    padding-top: 0 !important;
    display: inline-flex;
    justify-content: center;
}

.progress-card {
    border: 1px solid #e0e6ed !important;
    border-radius: 12px !important;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05) !important;
    background: #ffffff;
}

.step-item {
    transition: all 0.2s ease-in-out;
    border: 1px solid transparent;
}

.step-item:hover {
    background-color: #f8fafc;
}

.step-completed {
    background-color: #f0fdf4 !important;
    border: 1px solid #1c8f44 !important;
}

.min-height-24 {
    min-height: 24px !important;
}

.section-title {
    border-bottom: 2px solid #1976d2;
    padding-bottom: 4px;
}

.border-box {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 10px;
    background-color: #fafafa;
    max-height: 150px;
    overflow-y: auto;
}
</style>